import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Field } from 'redux-form'

import { renderTextField } from '../../Forms/fieldRenderers'

export class OperacionesAltaFumigadoSiloDialogView extends Component {
  render () {
    const {
      silo
    } = this.props
    return (
      <div>
        <Row>
          <Col md={12}>
            <h2>Fumigado de {silo.nombreCorto}</h2>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name='producto'
              label='Producto'
              type='text'
              component={renderTextField}
              placeholder=''
            />
          </Col>
          <Col md={6}>
            <Field
              name='observaciones'
              label='Observaciones'
              type='text'
              component={renderTextField}
              placeholder=''
            />
          </Col>
        </Row>
      </div>
    )
  }
}
